import React from 'react'

import { TableRow } from './TableRow'
import { LoadingRow } from './LoadingRow'

export function TableBody({
  coachOrgId,
  loading,
  filteredCollections,
  offset,
  currentPage,
  pageLimit,
  setModalCol,
  setEditDialogOpen,
}) {
  const nextPageStartIdx = currentPage * pageLimit
  return (
    <tbody className='bg-white divide-y divide-gray-200'>
      {loading ? (
        <Loading />
      ) : (
        <TableRows
          coachOrgId={coachOrgId}
          pageStartIdx={offset}
          nextPageStartIdx={nextPageStartIdx}
          filteredCollections={filteredCollections}
          setModalCol={setModalCol}
          setEditDialogOpen={setEditDialogOpen}
        />
      )}
    </tbody>
  )
}

function Loading() {
  const numRows = 10
  return [...Array(numRows).keys()].map((key) => <LoadingRow key={key} />)
}

function TableRows({
  coachOrgId,
  pageStartIdx,
  nextPageStartIdx,
  filteredCollections,
  setModalCol,
  setEditDialogOpen,
}) {
  return filteredCollections.map(([collectionKey, collection], index) => {
    const isOnCurrPage = index >= pageStartIdx && index < nextPageStartIdx

    if (isOnCurrPage) {
      return (
        <TableRow
          key={collectionKey}
          coachOrgId={coachOrgId}
          collectionKey={collectionKey}
          collection={collection}
          setModalCol={setModalCol}
          setEditDialogOpen={setEditDialogOpen}
        />
      )
    } else {
      return null
    }
  })
}
